var _ellipse, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 71,
    viewBox: "0 0 99 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.4219,
    cy: 35.3284,
    rx: 30,
    ry: 30,
    fill: "#AEE4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6758 36.9324L46.4049 44.6615L65.7279 25.3386",
    stroke: "#13100D",
    strokeWidth: 1.61042
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.75781,
    y: 25.9949,
    width: 15.1667,
    height: 9.33333,
    rx: 2.33359,
    fill: "#D9EFED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.421875,
    y: 37.6616,
    width: 11.6667,
    height: 9.33333,
    rx: 2.33359,
    fill: "#D9EFED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4219,
    y: 37.6616,
    width: 10.5,
    height: 9.33333,
    rx: 2.33359,
    fill: "#D9EFED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2578,
    y: 38.8281,
    width: 15.1667,
    height: 9.33333,
    rx: 2.33359,
    fill: "#D9EFED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.9219,
    y: 38.8281,
    width: 7.00001,
    height: 9.33333,
    rx: 2.33359,
    fill: "#D9EFED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 73.9219,
    y: 25.9949,
    width: 16.3333,
    height: 9.33333,
    rx: 2.33359,
    fill: "#D9EFED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cace108f7b2896b679754877fedfbd04.svg";
export { ForwardRef as ReactComponent };